import * as z from "zod";

export const updateReturnWithKeepFeesAndBonuses = {
  name: "updateReturnWithKeepFeesAndBonuses" as const,
  input: z.object({ id: z.string(), keepFeesAndBonuses: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
